export default __webpack_public_path__ + "static/media/kitchen3-before2-1440w.da6e428f.webp";